// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"aee6ea13","288":"3627080a","311":"10acd71b","385":"cd2366c1","498":"0a185c0a","703":"2b1350a0","856":"a99acef2","885":"bcaed955"}[chunkId] + ".chunk.js";
};